module.exports = __webpack_public_path__ + "img/home_menu_head.73187d36.png";